import { dashboardService } from '../services';
import { dashboardConstants } from '../constants';
import { alertActions } from '.';

export const dashboardActions = {
    fetchData,
    fetchLoyalityPoint,
    loadingData,
    TopfetchLoyalityPoint
};

function fetchData(obj) {
  
    return dispatch => {
        dispatch(request());

        return dashboardService.fetchData(obj).then(
            response => {
                dispatch(loadingData(false));

                if (response && response.ResponseData) {
                    dispatch(success(response.ResponseData || []));
               
                } else {
                    console.warn("ResponseData is null or undefined, sending empty array.");
                    dispatch(success([])); // Dispatch an empty array to prevent errors
                }
            },
            error => {
                dispatch(loadingData(false));
                dispatch(failure(error.toString()));
                dispatch(alertActions.error(error.toString()));
            }
        );
    };

    function request() { return { type: dashboardConstants.GETALL_REQUEST }; }
    function success(datas) { return { type: dashboardConstants.GETALL_SUCCESS, datas }; }
    function failure(error) { return { type: dashboardConstants.GETALL_FAILURE, error }; }
}


function fetchLoyalityPoint(obj) {
    return dispatch => {
        dispatch(request());

        return dashboardService.fetchLoyalityPoint(obj).then(
            response => {
                dispatch(loadingData(false));
                dispatch(success(response.ResponseData));

            },
            error => {
                dispatch(failure(error.toString()));
                dispatch(alertActions.error(error.toString()));
            }
        );
    };

    function request() { return { type: dashboardConstants.GETALL_LOYALITYREQUEST }; }
    function success(dates) { return { type: dashboardConstants.GETALL_SUCCESS, dates }; }
    function failure(error) { return { type: dashboardConstants.GETALL_FAILURE, error }; }

}

function TopfetchLoyalityPoint(obj) {
    return dispatch => {
        dispatch(request());

        return dashboardService.TopfecthLoyalityPoint(obj).then(
            response => {
                dispatch(loadingData(false));

                if (response && response.ResponseData) {
                    dispatch(success(response.ResponseData));
                } else {
                    console.warn("ResponseData is undefined, sending empty array.");
                    dispatch(success([])); // Prevent errors by dispatching an empty array
                }
            },
            error => {
                dispatch(failure(error.toString()));
                dispatch(alertActions.error(error.toString()));
            }
        );
    };

    function request() { return { type: dashboardConstants.GETALL_REQUEST }; }
    function success(dates) { return { type: dashboardConstants.GETALL_SUCCESS, dates }; }
    function failure(error) { return { type: dashboardConstants.GETALL_FAILURE, error }; }
}



function loadingData(isLoading) {
    return {
        type: dashboardConstants.LOADING_REQUEST,
        isLoading
    };
}

